import {
  DateInputField,
  GridItem,
  TextInputField,
} from "@certn/cascadia-react";
import { S3FileInfo } from "@certn/cascadia-react/deprecated/upload/types";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Field, useField } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { CountrySelect } from "../../../../components/AddressInput";
import {
  ApplicantDocumentUpload,
  convertDocumentToS3FileInfo,
} from "../../../../components/ApplicantDocumentUpload";

export function PassportInputField({
  field: config,
}: {
  field: components["schemas"]["PassportCheckField"];
}) {
  const { t } = useTranslation();
  const [files, setFiles] = useState<S3FileInfo[]>(() =>
    config.value ? [convertDocumentToS3FileInfo(config.value)] : []
  );
  const { applicantId } = useParams();
  const [, meta, helpers] = useField(`${config.name}.id`);

  const handleFilesChange = (files: S3FileInfo[]) => {
    helpers.setValue(files[0]?.document?.document_id ?? null);
    setFiles(files);
  };

  return (
    <>
      <GridItem>
        <ApplicantDocumentUpload
          isRequired
          documentType="PASSPORT"
          applicantId={applicantId ?? ""}
          files={files}
          setFiles={handleFilesChange}
          error={meta.error}
          testID="passport-input-document-upload"
        />
      </GridItem>

      <GridItem>
        <Field
          as={TextInputField}
          name={`${config.name}.document_number`}
          label={t("ID number")}
          isRequired
          testID="passport-input-passport-number-input"
        />
      </GridItem>

      <GridItem>
        <Field
          as={DateInputField}
          name={`${config.name}.document_expiration`}
          label={t("ID expiration")}
          isRequired
          testID="passport-input-passport-expiration-date-select"
        />
      </GridItem>

      <GridItem>
        <CountrySelect
          name={`${config.name}.document_issuing_country`}
          label={t("Issuing country")}
          isRequired
          testID="passport-input-passport-issuing-country-select"
        />
      </GridItem>

      <GridItem>
        <Field
          as={TextInputField}
          name={`${config.name}.document_issuing_province_state`}
          label={t("Issuing province, state or territory")}
          isRequired
          testID="passport-input-passport-issuing-province-input"
        />
      </GridItem>
    </>
  );
}
